import { DeviceService } from './../../shared/services/device.service';
import { Banner } from './home.model';
import { BannerService } from './../../shared/services/banner.service';
import { Component, OnInit } from '@angular/core';
import { KeyValue } from '@angular/common';

import * as _ from 'lodash';

declare var $: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(private bannerService: BannerService, private deviceService: DeviceService) { }
  customOptions: any = {
    autoplay: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    fade: false,
    cssEase: 'linear',
    items: 1
  };
  slides: Banner;
  deviceByLabel: any;
  deviceByBrand: any;

  ngOnInit() {

    this.bannerService.getBanner('slide').subscribe(
      res => {
        this.slides = (res as any).data;
        // console.log(this.slides);
      },
      err => {
        console.log(err);
      }
    );

    this.deviceService.getHomePageList('label').subscribe(
      res => {
        this.deviceByLabel = res;
        // console.log(res);
      },
      err => {
        console.log(err);
      }
    );

    this.deviceService.getHomePageList('brand').subscribe(
      res => {
        this.deviceByBrand = res;
        // console.log(res);
      },
      err => {
        console.log(err);
      }
    );
  }

  reverseKeyOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.key > b.key ? -1 : b.key > a.key ? 1 : 0;
  }

  sortObject() {
    return;
  }

  goToLink(url: string) {
    window.open(url);
}
}
